module.exports = __webpack_public_path__ + "img/cards2_p.f875301c.svg";